import { Navigate } from 'react-router-dom'

export function AdminUsersPage() {
  return <Navigate to="/admin/users/staff" replace />
}
